export const validation = {
  headingMaxChar: 120,
  paragraphMaxChar: 1500,
  links: {
    min: 0,
    max: 10
  }
}
